import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PrathamForm } from "@/components/forms/PrathamForm";
import { RevealEmail } from "@/components/site/RevealEmail";

export default function PrathamEnquiry() {
  return (
    <section className="shell pb-24 pt-32 sm:pb-32 sm:pt-40" data-testid="pratham-enquiry-page">
      <Link to="/#vessels" className="inline-flex items-center gap-2 text-sm text-fg-2 hover:text-signal"><ArrowLeft className="h-4 w-4" />Back to Pratham</Link>
      <div className="mt-10 grid items-start gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="eyebrow text-signal">Our first vessel</p>
          <h1 className="mt-5 text-5xl font-[540] leading-[1.02] tracking-[-0.04em] text-fg sm:text-6xl">Enquire about Pratham.</h1>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-fg-2">Tell us what you need to carry, and where. Your message goes straight to the founders.</p>
          <img src="/models/pratham/container.png?v=0.5-finishes2" alt="Pratham, our unmanned supply vessel, carrying a 20 ft container" className="my-8 hidden w-full lg:block" />
          <p className="mb-6 mt-6 text-sm leading-relaxed text-fg-3">Pratham is in development. We’d like to hear from people who could put it to work.</p>
          <RevealEmail label="Prefer email? Show the founders’ address" testId="pratham-reveal-email" />
        </div>
        <div className="rounded-3xl border border-white/[0.08] bg-ink-2 p-6 sm:p-10 lg:col-span-7">
          <PrathamForm />
        </div>
      </div>
    </section>
  );
}
